export default "__VITE_ASSET__DT8YQB2$__"